import SwipeableDrawer from "@mui/material/SwipeableDrawer";

export default SwipeableDrawer;
